var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout-item md-size-15"},[_c('md-button',{staticClass:"icon-button-size-40 md-icon-button icon-button",class:_vm.isRaised(_vm.item),attrs:{"disabled":_vm.disabled}},[_c('md-icon',{class:_vm.isRaised(_vm.item, true)},[_vm._v("sync_problem")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }